/**
 * AutoCAD Color Index (ACI) — 256-color palette.
 *
 * Sources cross-referenced:
 *   - ezdxf DXF_DEFAULT_COLORS (https://github.com/mozman/ezdxf)
 *   - gohtx.com ACI table (https://gohtx.com/acadcolors.php)
 *   - temblast.com ACI table (https://www.temblast.com/songview/color3.htm)
 *
 * Index  0      = BYBLOCK placeholder (black)
 * Index  1–9    = Standard named colors + grays
 * Index 10–249  = Extended HSV-based color wheel (24 hues × 10 shades)
 * Index 250–255 = Grayscale ramp (dark → light)
 */
export const ACI_COLORS: readonly string[] = [
  '#000000', // 0: BYBLOCK
  '#FF0000', // 1: Red
  '#FFFF00', // 2: Yellow
  '#00FF00', // 3: Green
  '#00FFFF', // 4: Cyan
  '#0000FF', // 5: Blue
  '#FF00FF', // 6: Magenta
  '#FFFFFF', // 7: White
  '#808080', // 8: Dark gray
  '#C0C0C0', // 9: Light gray
  '#FF0000', // 10
  '#FF7F7F', // 11
  '#A50000', // 12
  '#A55252', // 13
  '#7F0000', // 14
  '#7F3F3F', // 15
  '#4C0000', // 16
  '#4C2626', // 17
  '#260000', // 18
  '#261313', // 19
  '#FF3F00', // 20
  '#FF9F7F', // 21
  '#A52900', // 22
  '#A56752', // 23
  '#7F1F00', // 24
  '#7F4F3F', // 25
  '#4C1300', // 26
  '#4C2F26', // 27
  '#260900', // 28
  '#261713', // 29
  '#FF7F00', // 30
  '#FFBF7F', // 31
  '#A55200', // 32
  '#A57C52', // 33
  '#7F3F00', // 34
  '#7F5F3F', // 35
  '#4C2600', // 36
  '#4C3926', // 37
  '#261300', // 38
  '#261C13', // 39
  '#FFBF00', // 40
  '#FFDF7F', // 41
  '#A57C00', // 42
  '#A59152', // 43
  '#7F5F00', // 44
  '#7F6F3F', // 45
  '#4C3900', // 46
  '#4C4226', // 47
  '#261C00', // 48
  '#262113', // 49
  '#FFFF00', // 50
  '#FFFF7F', // 51
  '#A5A500', // 52
  '#A5A552', // 53
  '#7F7F00', // 54
  '#7F7F3F', // 55
  '#4C4C00', // 56
  '#4C4C26', // 57
  '#262600', // 58
  '#262613', // 59
  '#BFFF00', // 60
  '#DFFF7F', // 61
  '#7CA500', // 62
  '#91A552', // 63
  '#5F7F00', // 64
  '#6F7F3F', // 65
  '#394C00', // 66
  '#424C26', // 67
  '#1C2600', // 68
  '#212613', // 69
  '#7FFF00', // 70
  '#BFFF7F', // 71
  '#52A500', // 72
  '#7CA552', // 73
  '#3F7F00', // 74
  '#5F7F3F', // 75
  '#264C00', // 76
  '#394C26', // 77
  '#132600', // 78
  '#1C2613', // 79
  '#3FFF00', // 80
  '#9FFF7F', // 81
  '#29A500', // 82
  '#67A552', // 83
  '#1F7F00', // 84
  '#4F7F3F', // 85
  '#134C00', // 86
  '#2F4C26', // 87
  '#092600', // 88
  '#172613', // 89
  '#00FF00', // 90
  '#7FFF7F', // 91
  '#00A500', // 92
  '#52A552', // 93
  '#007F00', // 94
  '#3F7F3F', // 95
  '#004C00', // 96
  '#264C26', // 97
  '#002600', // 98
  '#132613', // 99
  '#00FF3F', // 100
  '#7FFF9F', // 101
  '#00A529', // 102
  '#52A567', // 103
  '#007F1F', // 104
  '#3F7F4F', // 105
  '#004C13', // 106
  '#264C2F', // 107
  '#002609', // 108
  '#132617', // 109
  '#00FF7F', // 110
  '#7FFFBF', // 111
  '#00A552', // 112
  '#52A57C', // 113
  '#007F3F', // 114
  '#3F7F5F', // 115
  '#004C26', // 116
  '#264C39', // 117
  '#002613', // 118
  '#13261C', // 119
  '#00FFBF', // 120
  '#7FFFDF', // 121
  '#00A57C', // 122
  '#52A591', // 123
  '#007F5F', // 124
  '#3F7F6F', // 125
  '#004C39', // 126
  '#264C42', // 127
  '#00261C', // 128
  '#132621', // 129
  '#00FFFF', // 130
  '#7FFFFF', // 131
  '#00A5A5', // 132
  '#52A5A5', // 133
  '#007F7F', // 134
  '#3F7F7F', // 135
  '#004C4C', // 136
  '#264C4C', // 137
  '#002626', // 138
  '#132626', // 139
  '#00BFFF', // 140
  '#7FDFFF', // 141
  '#007CA5', // 142
  '#5291A5', // 143
  '#005F7F', // 144
  '#3F6F7F', // 145
  '#00394C', // 146
  '#26424C', // 147
  '#001C26', // 148
  '#132126', // 149
  '#007FFF', // 150
  '#7FBFFF', // 151
  '#0052A5', // 152
  '#527CA5', // 153
  '#003F7F', // 154
  '#3F5F7F', // 155
  '#00264C', // 156
  '#26394C', // 157
  '#001326', // 158
  '#131C26', // 159
  '#003FFF', // 160
  '#7F9FFF', // 161
  '#0029A5', // 162
  '#5267A5', // 163
  '#001F7F', // 164
  '#3F4F7F', // 165
  '#00134C', // 166
  '#262F4C', // 167
  '#000926', // 168
  '#131726', // 169
  '#0000FF', // 170
  '#7F7FFF', // 171
  '#0000A5', // 172
  '#5252A5', // 173
  '#00007F', // 174
  '#3F3F7F', // 175
  '#00004C', // 176
  '#26264C', // 177
  '#000026', // 178
  '#131326', // 179
  '#3F00FF', // 180
  '#9F7FFF', // 181
  '#2900A5', // 182
  '#6752A5', // 183
  '#1F007F', // 184
  '#4F3F7F', // 185
  '#13004C', // 186
  '#2F264C', // 187
  '#090026', // 188
  '#171326', // 189
  '#7F00FF', // 190
  '#BF7FFF', // 191
  '#5200A5', // 192
  '#7C52A5', // 193
  '#3F007F', // 194
  '#5F3F7F', // 195
  '#26004C', // 196
  '#39264C', // 197
  '#130026', // 198
  '#1C1326', // 199
  '#BF00FF', // 200
  '#DF7FFF', // 201
  '#7C00A5', // 202
  '#9152A5', // 203
  '#5F007F', // 204
  '#6F3F7F', // 205
  '#39004C', // 206
  '#42264C', // 207
  '#1C0026', // 208
  '#211326', // 209
  '#FF00FF', // 210
  '#FF7FFF', // 211
  '#A500A5', // 212
  '#A552A5', // 213
  '#7F007F', // 214
  '#7F3F7F', // 215
  '#4C004C', // 216
  '#4C264C', // 217
  '#260026', // 218
  '#261326', // 219
  '#FF00BF', // 220
  '#FF7FDF', // 221
  '#A5007C', // 222
  '#A55291', // 223
  '#7F005F', // 224
  '#7F3F6F', // 225
  '#4C0039', // 226
  '#4C2642', // 227
  '#26001C', // 228
  '#261321', // 229
  '#FF007F', // 230
  '#FF7FBF', // 231
  '#A50052', // 232
  '#A5527C', // 233
  '#7F003F', // 234
  '#7F3F5F', // 235
  '#4C0026', // 236
  '#4C2639', // 237
  '#260013', // 238
  '#26131C', // 239
  '#FF003F', // 240
  '#FF7F9F', // 241
  '#A50029', // 242
  '#A55267', // 243
  '#7F001F', // 244
  '#7F3F4F', // 245
  '#4C0013', // 246
  '#4C262F', // 247
  '#260009', // 248
  '#261317', // 249
  '#333333', // 250: Gray (darkest)
  '#505050', // 251: Gray
  '#696969', // 252: Gray
  '#828282', // 253: Gray
  '#BEBEBE', // 254: Gray
  '#FFFFFF', // 255: Gray (lightest)
] as const;

export function aciToHex(aci: number): string | undefined {
  if (aci === 0 || aci === 256) return undefined;
  if (aci < 0 || aci > 255) return undefined;
  return ACI_COLORS[aci];
}

export function aciToDisplayColor(aci: number, isDarkTheme: boolean): string {
  if (aci === 7) return isDarkTheme ? '#FFFFFF' : '#000000';
  return ACI_COLORS[Math.abs(aci)] ?? (isDarkTheme ? '#FFFFFF' : '#000000');
}

export function trueColorToHex(trueColor: number): string {
  const r = (trueColor >> 16) & 0xFF;
  const g = (trueColor >> 8) & 0xFF;
  const b = trueColor & 0xFF;
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}
